<button class="btn text-primary bg-dark" (click)="openModal($event)">
  <i class="bi bi-share"></i>
</button>

<div class="modal fade" id="shareModal" tabindex="-1" aria-labelledby="shareModalLabel">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header bg-dark text-primary">
        <h5 class="modal-title" id="shareModalLabel">{{ 'SHARE_TITLE' | translate }}</h5>
      </div>

      <div class="modal-body text-center bg-dark">
        <p class="mb-3">{{ currentUrl }}</p>

        <div class="d-grid gap-2">
          <!-- Copy link -->
          <button class="btn btn-outline-light" (click)="copyLink()">
            <i class="bi bi-clipboard"></i>
            {{ 'SHARE_COPY' | translate }}
          </button>

          <!-- Email -->
          <button class="btn btn-outline-primary" (click)="shareByEmail()">
            <i class="bi bi-envelope"></i> {{ 'SHARE_EMAIL' | translate }}
          </button>

          <!-- WhatsApp -->
          <button class="btn btn-outline-success" (click)="shareByWhatsApp()">
            <i class="bi bi-whatsapp"></i> {{ 'SHARE_WHATSSAPP' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
